import Cleave from 'cleave.js';

export const inputMask = (el, mask, format, delimiter = ',') => {
  let cleaveOptions;

  switch (mask) {
    case 'currency':
      cleaveOptions = {
        numeral: true,
        numeralThousandsGroupStyle: 'thousand',
        delimiter,
        // eslint-disable-next-line no-constant-binary-expression
        prefix: `${format.replaceAll(' ', '')} ` || '£ ',
      };
      break;
    case 'dob':
      cleaveOptions = {
        date: true,
        delimiter: ' - ',
        datePattern: ['d', 'm', 'Y'],
      };
      if (format) {
        Object.assign(cleaveOptions, format);
      }
      break;
    case 'nationalInsuranceNumber':
      cleaveOptions = {
        delimiter: ' ',
        blocks: [2, 2, 2, 2, 1],
        uppercase: true,
      };
      el.addEventListener('keypress', e => {
        let start = e.target.selectionStart;
        const key = e.key.toLowerCase();
        const rawvalue = e.target.value.replace(/ /g, '');
        if (key.length !== 1) {
          return;
        }
        if (start > rawvalue.length) {
          start = rawvalue.length;
        }
        const isC = key >= 'a' && key <= 'z';
        const isN = key >= '0' && key <= '9';
        const pattern = [isC, isC, isN, isN, isN, isN, isN, isN, isC];
        if (!pattern[start]) {
          e.preventDefault();
        }
      });
      break;
    case 'number':
      cleaveOptions = {
        numeral: true,
        stripLeadingZeroes: true,
        numeralThousandsGroupStyle: 'none',
      };
      break;
    case 'percentage':
      cleaveOptions = {
        numeral: true,
        numeralPositiveOnly: true,
        numeralIntegerScale: 2,
      };
      break;
    default:
  }

  if (el && Object.keys(cleaveOptions).length !== 0) {
    new Cleave(el, cleaveOptions);
  }
};

export default inputMask;
